import { FocusDirective } from '@/Directives/FocusDirective';
import { ReplaceIconDirective } from '@/Directives/ReplaceIconDirective';
import { ScrollToFixedDirective } from '@/Directives/ScrollToFixedDirective';
import { ScrollToFixedSimpleDirective } from '@/Directives/ScrollToFixedSimpleDirective';
import { TippyDirective } from '@/Directives/TippyDirective';
import { ClickOutsideDirective } from '@/Directives/ClickOutsideDirective';

export const registerDirectives = app => {
  app.directive('focus', FocusDirective);
  app.directive('replace-icon', ReplaceIconDirective);
  app.directive('scroll-to-fixed', ScrollToFixedDirective);
  app.directive('scroll-to-fixed-simple', ScrollToFixedSimpleDirective);
  app.directive('tippy', TippyDirective);
  app.directive('click-outside', ClickOutsideDirective);
};
